export class Installer {
    constructor(title: string, version: string, downloadUrl: string, description: string = ''){
        this.label = title;
        this.description = description;
        this.downloadUrl = downloadUrl;
        this.version = version;
    }
    version: string;
    downloadUrl: string;
    label: string;
    description: string;
    filename: string;
    attachment: Int8Array;
}